import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "min-h-[60vh] flex items-center justify-center px-4 py-16" }
const _hoisted_2 = { class: "w-full max-w-[640px] rounded-[2.4rem] border border-black/10 bg-white p-8 shadow-sm text-center space-y-4" }
const _hoisted_3 = { class: "m-0 text-[1.6rem] font-semibold text-black" }
const _hoisted_4 = {
  key: 0,
  class: "m-0 text-[1.3rem] text-red-600"
}
const _hoisted_5 = {
  key: 1,
  class: "m-0 text-[1.3rem] text-[color:var(--gray)]"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('Processing payment, please wait…')), 1),
      (_ctx.errorMessage)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.errorMessage), 1))
        : (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.$t('We are confirming your payment. This may take a few seconds.')), 1)),
      (_ctx.errorMessage)
        ? (_openBlock(), _createElementBlock("button", {
            key: 2,
            type: "button",
            class: "inline-flex items-center justify-center gap-2 rounded-xl bg-black px-4 py-2 text-[1.3rem] font-semibold text-white transition hover:bg-black/90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-black",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
          }, _toDisplayString(_ctx.$t('Return to checkout')), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}